import { useRemoteFeatureFlag } from '@shared/core/featureFlags/remoteFeatureFlags';
import { useMemo } from 'react';

export const useMinimumPercentageOffToDisplay = () => {
  const { value: minimumPercentageOffToDisplay, loading: loadingMinimumPercentageOffToDisplay, payload: minimumPercentageOffToDisplayPayload } = useRemoteFeatureFlag(
    'minimumPercentageOffToDisplay'
  );
  const minimumPercentageOffToDisplayValue = useMemo(() => {
    if (minimumPercentageOffToDisplay === 'on') {
      const minimumPercentageOffToDisplayValueFromPayload = (minimumPercentageOffToDisplayPayload as { minimumPercentageOffToDisplay: number })?.minimumPercentageOffToDisplay;
      return Number.isFinite(minimumPercentageOffToDisplayValueFromPayload) ? minimumPercentageOffToDisplayValueFromPayload : 0;
    }
    return 0;
  }, [minimumPercentageOffToDisplay, minimumPercentageOffToDisplayPayload]);

  return { minimumPercentageOffToDisplayValue, loadingMinimumPercentageOffToDisplay };
};
